/**
 * Cookie Consent Types
 * 
 * Çerez yönetimi için TypeScript type tanımlamaları
 */

export interface CookieCategory {
  enabled: boolean;
  required: boolean;
  title: string;
  description: string;
}

export interface CookieCategories {
  necessary: CookieCategory;
  analytics: CookieCategory;
  marketing: CookieCategory;
  functional: CookieCategory;
}

export interface CookieConsentAttributes {
  title: string;
  description: string;
  policy_url: string | null;
  categories: CookieCategories;
  version: string;
  language: {
    code: string;
    name: string;
  };
}

export interface CookieConsentResponse {
  success: boolean;
  data: {
    id: number;
    attributes: CookieConsentAttributes;
  };
  needs_reconsent?: boolean;
}

export interface CookieServiceScript {
  id: number;
  type: string;
  position: 'head' | 'body';
  content: string;
  load_type?: string;
  async?: boolean;
  defer?: boolean;
}

export interface CookieServiceAttributes {
  key: string;
  name: string;
  category: 'necessary' | 'analytics' | 'marketing' | 'functional';
  is_active: boolean;
  script?: CookieServiceScript | null;
  script_head?: string | null; // Computed from script object
  script_body?: string | null; // Computed from script object
  cookies_meta: Array<{
    name: string;
    domain?: string | null;
    path?: string | null;
    provider?: string;
    purpose?: string;
    expiry?: string;
    type?: string;
  }> | null;
  load_strategy: 'after_consent' | 'defer' | 'async';
  priority: number;
}

export interface CookieServiceResponse {
  success: boolean;
  data: Array<{
    id: number;
    attributes: CookieServiceAttributes;
  }>;
}

export interface CookiePreferences {
  consentGiven: boolean;
  timestamp: number;
  version: string;
  categories: {
    necessary: boolean; // Her zaman true, değiştirilemez
    analytics: boolean;
    marketing: boolean;
    functional: boolean;
  };
}

export interface CookiePreferencesLogPayload {
  preferences: CookiePreferences;
  site_id?: number;
}

export const COOKIE_PREFERENCES_KEY = 'cookie_consent_preferences';

